import * as React from 'react';
import {
    forceEnableNotificationsBannerDismiss,
    getForceEnableBanner,
    getPermission,
    requestBrowserPermission,
} from '@/redux/modules/notification';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import ButtonLink from '@liveauctioneers/caterwaul-components/lib/ButtonLink/ButtonLink';
import Cookies from 'universal-cookie';
import { enableBrowserNotificationsUrl } from '@/utils/urls';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons/faExclamationTriangle';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { getPlacedHighBid } from '@/redux/modules/biddingInfo';
import notificationPermissions from '@/enums/notificationPermissions';
import styles from './DismissableGetWebNotificationsBanner.module.scss';

const cookie = new Cookies();
const COOKIE_MAX_AGE = 86400 * 365; // 365 days
const COOKIE_NAME = 'dismissableNotificationBanner';
const COOKIE_BODY = 'dismissed';

const DismissableGetWebNotificationsBanner = () => {
    const dispatch = useDispatch();
    const forceEnableBanner = useSelector(getForceEnableBanner);
    const permission = useSelector(getPermission);
    const placedHighBid = useSelector(getPlacedHighBid);
    const [dismissed, setDismissed] = React.useState(false);
    const [forceDismissed, setForceDismissed] = React.useState(false);

    const isBannerDismissed = () => {
        const hasBeenChecked = cookie.get(COOKIE_NAME);
        setDismissed(COOKIE_BODY === hasBeenChecked);
        return COOKIE_BODY === hasBeenChecked;
    };

    const setCookieChecked = () => {
        cookie.set(COOKIE_NAME, COOKIE_BODY, { maxAge: COOKIE_MAX_AGE });
        setDismissed(true);
        setForceDismissed(true);
        dispatch(forceEnableNotificationsBannerDismiss());
    };

    const onClickEnableNotifications = () => {
        dispatch(requestBrowserPermission());
    };

    React.useEffect(() => {
        if (!forceEnableBanner && forceEnableBanner) {
            setForceDismissed(false);
        }
    }, [forceEnableBanner]);

    React.useEffect(() => {
        isBannerDismissed();
    }, []);

    if (!forceEnableBanner) {
        if (!placedHighBid || permission === notificationPermissions.GRANTED || Boolean(dismissed)) {
            return null;
        }
    } else {
        if (Boolean(forceDismissed)) {
            return null;
        }
    }

    const disallowedNotifications = permission === notificationPermissions.DENIED;

    return (
        <div className={styles.webNotificationContainer} id="webNotificationsBanner">
            {disallowedNotifications ? (
                <div className={styles.innerContainer} id="webNotificationsDenied">
                    <FontAwesomeIcon className={styles.warningSignIcon} icon={faExclamationTriangle} />
                    <div className={styles.getNotificationText}>
                        <FormattedMessage id="notifications.modify_your_browser_preferences" />
                    </div>
                    <ButtonLink
                        className={styles.button}
                        external
                        rel="noopener"
                        target="_blank"
                        url={enableBrowserNotificationsUrl}
                    >
                        <FormattedMessage id="top_learn_more" />
                    </ButtonLink>
                </div>
            ) : (
                <div className={styles.innerContainer} id="webNotificationsDefault">
                    <div className={styles.getNotificationText}>
                        <FormattedMessage id="notifications.get_notifications_when_outbid" />
                    </div>
                    <Button className={styles.button} onClick={onClickEnableNotifications}>
                        <FormattedMessage id="notifications.enable_browser_notifications" />
                    </Button>
                </div>
            )}
            <FontAwesomeIcon className={styles.closeBox} icon={faTimes} onClick={setCookieChecked} />
        </div>
    );
};

export default DismissableGetWebNotificationsBanner;
